import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './actionAgentErrorMsg.view.html';
let ActionAgentErrorMsgComponent = class ActionAgentErrorMsgComponent {
    //#endregion
    constructor() { }
};
ActionAgentErrorMsgComponent = __decorate([
    Component({
        template,
        bindings: {
            isValidActionName: '<',
            isUniqueTitle: '<',
            action: '<',
        },
        controllerAs: '$ctrl',
    }),
    __metadata("design:paramtypes", [])
], ActionAgentErrorMsgComponent);
export { ActionAgentErrorMsgComponent };
